module.exports = __webpack_public_path__ + "img/MY.b977463a.svg";